<template>
  <div>
    <button @click="checkUpdates(true)">بررسی آپدیت‌ها</button>
    <button @click="checkUpdates(false)">توقف</button>
    <p>{{ updateCount }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      updateCount: 0,
    };
  },
  methods: {
    checkUpdates(continueBot) {
      console.log("continueBot: ", continueBot);
      console.log("---Ready");
      var axios = require("axios");
      var FormData = require("form-data");
      var data = new FormData();
      data.append("offset", 0);
      data.append("continueBot", continueBot);

      var config = {
        method: "post",
        url: this.$GetapiBase() + "Bale/webhook",
        headers: {},
        data: "",
      };
      axios(config).then((result) => {
        console.log("---done");
        console.log(result.data);
      });
      console.log("---finish");
    },
  },
};
</script>
